import styles from './index.less';
import { Dialog, SwipeAction, SwipeActionRef } from 'antd-mobile';
import { Action } from 'antd-mobile/es/components/swipe-action';
import FloatButton from '@/components/FloatButton';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useModel } from '@umijs/max';
import {
  querySetDefaultCommunity,
  queryUnBindCommunity,
} from '@/pages/Community/service';
import SelectCommunity from '@/components/SelectCommunity';
import { CommunityInfoType } from '@/pages/Home/interface';
import NoData from '@/components/NoData';

const Community = () => {
  const ref = useRef<SwipeActionRef>(null);
  const { communityInfo, handleQueryBindCommunity } = useModel(
    'useCommunity',
    (model) => ({
      communityInfo: model.communityInfo,
      handleQueryBindCommunity: model.handleQueryBindCommunity,
    }),
  );
  const { userInfo } = useModel('useGlobal', (model) => ({
    userInfo: model.userInfo,
  }));
  const [selectCommunityVisible, setSelectCommunityVisible] = useState(false);
  const [deleteCommunityInfo, setDeleteCommunityInfo] =
    useState<CommunityInfoType>();

  useEffect(() => {
    if (!selectCommunityVisible && userInfo?.openid) {
      handleQueryBindCommunity();
    }
  }, [selectCommunityVisible, userInfo]);

  const handleSetDefaultCommunity = (id: string) => {
    querySetDefaultCommunity({
      communityId: id,
      openId: userInfo?.openid,
      communityIds: communityInfo?.map((a) => a.communityId)?.join(','),
      headImgUrl: userInfo?.headimgurl,
      nickName: userInfo?.nickname,
      // isDefault: 1,
    }).then((res) => {
      if (res?.code === 200) {
        handleQueryBindCommunity();
      }
    });
  };

  const onActionsReveal = (item: any) => {
    setDeleteCommunityInfo(item);
  };

  const RightAction: Action[] = [
    {
      key: 'delete',
      text: '删除',
      color: 'danger',
      onClick: async () => {
        await Dialog.confirm({
          content: '确定删除该小区吗？',
          onConfirm: async () => {
            console.log(deleteCommunityInfo, 'deleteCommunityInfo');
            await queryUnBindCommunity({
              communityId: deleteCommunityInfo?.communityId || '',
              openId: userInfo?.openid,
              isDefault: deleteCommunityInfo?.isDefault,
            }).then((res) => {
              if (res?.code === 200) {
                handleQueryBindCommunity();
              }
            });
          },
          onClose: () => {
            ref.current?.close();
          },
        });
      },
    },
  ];

  return (
    <Fragment>
      <div className={styles.container}>
        {communityInfo?.length ? (
          <>
            {communityInfo.map((item) => (
              <div className={styles['community-list']} key={item?.communityId}>
                <SwipeAction
                  ref={ref}
                  onActionsReveal={() => onActionsReveal(item)}
                  key={item?.communityId}
                  rightActions={RightAction}
                >
                  <div>
                    {item.isDefault === 1 && (
                      <div className={styles['default-label']}>默认小区</div>
                    )}
                    <div
                      style={{ paddingTop: item.isDefault ? 2 : 18 }}
                      className={styles.community}
                    >
                      <p>{item.communityName}</p>
                      {item.isDefault !== 1 && (
                        <span
                          onClick={() =>
                            handleSetDefaultCommunity(item.communityId)
                          }
                        >
                          设为默认小区
                        </span>
                      )}
                    </div>
                  </div>
                </SwipeAction>
              </div>
            ))}
          </>
        ) : (
          <NoData />
        )}
      </div>
      <SelectCommunity
        visible={selectCommunityVisible}
        close={setSelectCommunityVisible}
      />
      <FloatButton
        btnClick={() => setSelectCommunityVisible(true)}
        type={'community'}
      />
    </Fragment>
  );
};

export default Community;
